import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'qumra-input-file',
  styleUrl: 'qumra-input-file.css',
  shadow: true,
})
export class QumraInputFile {
  @Prop() keyVal: string;
  @Prop() label: string;
  @Prop() value: any;
  // @Prop() extensions: any;
  @Prop() icon: any;
  @Prop() handleChange: Function;

  render() {
    return (
      <div class="qumra-input">
        <div class=" font-bold">{this.label}</div>
        <div key={this.keyVal} class="qumra-input-container">
          <input
            type="file"
            onChange={event => this.handleChange(this.keyVal, (event.target as HTMLInputElement).files[0])}
            value={this.value}
            class="qumra-input-file"
            placeholder="Placeholder"
          />
          <svg width="34" height="35" viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.3542 22.8607H7.3856C4.87073 22.8607 2.83203 21.1245 2.83203 18.5787C2.83203 16.0329 4.87073 13.9691 7.3856 13.9691C7.55662 13.9691 7.72543 13.9787 7.89155 13.9973V13.9691H7.95419C7.91285 13.6336 7.89155 13.2917 7.89155 12.9448C7.89155 8.41893 11.5159 4.75 15.9868 4.75C19.0143 4.75 21.6537 6.43243 23.0423 8.92409C23.3817 8.87356 23.7288 8.84739 24.082 8.84739C27.994 8.84739 31.1654 12.0577 31.1654 16.0178C31.1654 19.6301 28.5266 22.2911 25.0939 22.7881H21.4258M16.4927 14.4813V30.25M16.4927 30.25L12.9036 26.7094M16.4927 30.25L19.987 26.7094" stroke="#9D9D9D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
{/* {this.extensions.length > 0 && this.extensions.map((item: string) => <span class="qumra-input-file-extensions">{item}</span>)} */}
        </div>
      </div>
    );
  }
}
